import { inject } from 'vue';

export function useIntercom() {
  const intercom = inject('intercom');

  if (!intercom) {
    console.error('Intercom service was not provided');
  }

  return intercom;
}
